<template>
  <loader object="#dbbfa7" color1="#ffffff" color2="#fdf8f4" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="5" name="circular"></loader>
</template>

<script>
export default {
  name: "loading",
  props: {
    minHeight: {
      type: String, default: () => {
        return '300px';
      }
    },
  },
  mounted() {
    document.getElementById("overlay-circular").setAttribute('style', `min-height:${this.minHeight}`);
  },
}
</script>

<style>
#overlay-circular {
  position: absolute !important;
  border-radius: 5px;
}
</style>
